export const commonListAction = {
    SET_COUNTRY_LIST: "SET_COUNTRY_LIST",
    SET_STATE_LIST: "SET_STATE_LIST",
    SET_CITY_LIST: "SET_CITY_LIST",
    SET_PINCODE_LIST: "SET_PINCODE_LIST",
    SET_CATEGORY_LIST: "SET_CATEGORY_LIST",
    SET_PRODUCT_LIST: "SET_PRODUCT_LIST"
};